export default __webpack_public_path__ + "static/iPad-Left-sm@2x-9a0374823788e87d82c9efea78b459be.jpg";